/**
 * Retourne la date - x nombre de jours par rapport à la date actuel
 */
export function datePrevious(previousDays: number, fromDate?: Date) {
    let myDate = new Date(fromDate == undefined ? new Date() : fromDate);
    myDate.setDate(myDate.getDate() - previousDays);
    return myDate;
}